import partnerOrderRequestRequests from './partnerOrderRequest'
import dispatcherReviewRequestRequests from './dispatcherReviewRequest'

export default {
  partnerOrderRequestRequests,
  dispatcherReviewRequestRequests,
}
